import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import moment from "moment";
import "moment/locale/sk";
import "moment/locale/cs";
import "moment/locale/en-gb";
import dayjs from "dayjs";
import "dayjs/locale/sk";
import "dayjs/locale/cs";

const isDevelopment = process.env.NODE_ENV === "development";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",

    // Pinned explicitly (2026-08-19, TAJMAC-PILOT-FE3c). This is already i18next's
    // DEFAULT, so setting it changes nothing today — it is here so that deliberately
    // EMPTY translation values stay empty. `account:departmentPlaceholder` is now "" in
    // all three locales (the owner asked for no suggested department); if this option
    // were ever flipped to false, i18next would treat "" as missing and render the raw
    // key ("departmentPlaceholder") inside the input instead.
    returnEmptyString: true,
    debug: isDevelopment,

    interpolation: {
      escapeValue: false,
    },

    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
      // Cache-busting (2026-07-23, QR-kiosk review §5 "raw i18n keys" bug): the JS
      // bundle is content-hashed but these JSON URLs were stable, so browsers kept
      // serving STALE cached translations against new code — new keys rendered as
      // raw key names even though the deployed files were correct. Bump this stamp
      // whenever locale JSON content changes (any locale commit) to force refetch.
      queryStringParams: { v: "20260825d" },
    },

    detection: {
      order: ["localStorage", "navigator", "htmlTag"],

      lookupLocalStorage: "i18nextLng",

      caches: ["localStorage"],
    },

    supportedLngs: ["sk", "en", "cs"],

    nonExplicitSupportedLngs: false,

    defaultNS: "common",
    ns: ["common", "account", "settings", "public", "layout", "myMachinery", "marketplace", "inventory", "servicing", "serviceOffers", "serviceBoard", "notifications", "partnerHub", "chatBot", "partnerships", "serviceTracking", "operations", "machineEvidence", "errors"],
    react: {
      useSuspense: true,
    },
  });

moment.locale(i18n.language);
dayjs.locale(i18n.language);
i18n.on('languageChanged', (lng) => {
  moment.locale(lng);
  dayjs.locale(lng);
});

export default i18n; 